import { formatTax } from './chunk-22INMNZK.mjs';
import { menuItemCardFactoryCore, getIsMenuTypeItemHiddenCore } from './chunk-MFMTSPFX.mjs';
import { calculatePriceText } from './chunk-G3WCWBRF.mjs';
import { i18n_config_default } from './chunk-EJ2TIXJU.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';
import isEqual from 'lodash/isEqual';

var ITEM_PRICES = ["itemPrice", "onlinePrice", "deliveryPrice", "toGoPrice"];
var getTaxesTextPair = (inputTaxIds, taxes) => inputTaxIds.map((taxId) => {
  const tax = taxes[taxId];
  const taxDescription = formatTax(tax == null ? void 0 : tax.taxType, tax == null ? void 0 : tax.typeData);
  return {
    text: tax == null ? void 0 : tax.name,
    description: taxDescription === "N/A" ? i18n_config_default.t("settingsModule.taxesSettings.taxesTable.taxTypes.table") : taxDescription
  };
});
var menuItemTableFactoryCore = (items, categories, subcategories, menuTypes, taxes, modifierGroups, prepStations, reportingGroups) => {
  return Object.values(items).map((item) => {
    const itemCoreCard = menuItemCardFactoryCore(
      { [item.itemId]: item },
      categories,
      subcategories,
      menuTypes
    )[0];
    const children = [];
    const prices = [];
    const taxIds = [];
    let quantity = null;
    const modifierGroupIds = [];
    const printerLocationIds = [];
    const categoriesSubcategories = [];
    let areTaxesDifferent = false;
    let areModifierGroupsDifferent = false;
    let arePrinterLocationsDifferent = false;
    let areCategoriesSubcategoriesDifferent = false;
    const getCategoriesSubcategoriesText = (inputCategoriesSubcategories) => inputCategoriesSubcategories.map((categorySubcategory) => {
      var _a, _b;
      const category = categories[categorySubcategory.categoryId || 0];
      const subcategory = subcategories[categorySubcategory.subcategoryId || 0];
      return {
        text: (_a = category == null ? void 0 : category.name) != null ? _a : i18n_config_default.t(
          "menuScreen.categoryDetails.associations.subcategories.noCategory"
        ),
        description: (_b = subcategory == null ? void 0 : subcategory.name) != null ? _b : ""
      };
    });
    const getModifierGroupsText = (inputModifierGroupIds) => inputModifierGroupIds.length > 0 ? inputModifierGroupIds.map((modifierGroupId) => {
      var _a;
      return (_a = modifierGroups[modifierGroupId]) == null ? void 0 : _a.name;
    }).join(", ") : void 0;
    const getReportingGroupsText = (inputReportingGroupIds = []) => inputReportingGroupIds.length > 0 ? inputReportingGroupIds.map((reportingGroupId) => {
      var _a;
      return (_a = reportingGroups[reportingGroupId]) == null ? void 0 : _a.name;
    }).join(", ") : void 0;
    const getPrinterLocationsText = (inputPrinterLocationIds) => inputPrinterLocationIds.length > 0 ? inputPrinterLocationIds.map((printerLocationId) => {
      var _a;
      return (_a = prepStations[printerLocationId]) == null ? void 0 : _a.name;
    }).join(", ") : void 0;
    Object.values(item.menuTypeVersions).forEach((menuTypeVersion) => {
      var _a, _b, _c;
      const categoryIdSet = /* @__PURE__ */ new Set();
      const subcategoryIdSet = /* @__PURE__ */ new Set();
      const menuTypeVersionPrices = [];
      const menuTypeVersionCategoriesSubcategories = Object.values((_a = menuTypeVersion.categoriesSubcategories) != null ? _a : {});
      const menuTypeVersionTaxIds = Array.from(
        /* @__PURE__ */ new Set([
          ...menuTypeVersion.taxIds,
          ...Object.values(
            menuTypeVersion.inheritedTaxes.categoryInheritedTaxes
          ).map((tax) => tax.id),
          ...Object.values(
            menuTypeVersion.inheritedTaxes.subcategoryInheritedTaxes
          ).map((tax) => tax.id),
          ...Object.values(
            menuTypeVersion.inheritedTaxes.menuTypeInheritedTaxes
          ).map((tax) => tax.id)
        ])
      );
      const menuTypeVersionModifierGroupIds = Object.keys(
        menuTypeVersion.modifierGroups
      ).map(Number);
      const menuTypeVersionPrinterLocationIds = menuTypeVersion.prepStationIds;
      menuTypeVersionTaxIds.forEach((taxId) => {
        if (!taxIds.includes(taxId)) {
          taxIds.push(taxId);
        }
      });
      menuTypeVersionModifierGroupIds.forEach((modifierGroupId) => {
        if (!modifierGroupIds.includes(modifierGroupId)) {
          modifierGroupIds.push(modifierGroupId);
        }
      });
      menuTypeVersionPrinterLocationIds.forEach((printerLocationId) => {
        if (!printerLocationIds.includes(printerLocationId)) {
          printerLocationIds.push(printerLocationId);
        }
      });
      menuTypeVersionCategoriesSubcategories.forEach((categorySubcategory) => {
        if (!categoriesSubcategories.some(
          (itemCategorySubcategory) => isEqual(itemCategorySubcategory, categorySubcategory)
        )) {
          categoriesSubcategories.push(categorySubcategory);
        }
      });
      if (!areTaxesDifferent && !isEqual(taxIds, menuTypeVersionTaxIds)) {
        areTaxesDifferent = true;
      }
      if (!areModifierGroupsDifferent && !isEqual(modifierGroupIds, menuTypeVersionModifierGroupIds)) {
        areModifierGroupsDifferent = true;
      }
      if (!arePrinterLocationsDifferent && !isEqual(printerLocationIds, menuTypeVersionPrinterLocationIds)) {
        arePrinterLocationsDifferent = true;
      }
      if (!areCategoriesSubcategoriesDifferent && (categoriesSubcategories.length !== menuTypeVersionCategoriesSubcategories.length || !!categoriesSubcategories.length && categoriesSubcategories.every(
        (itemCategorySubcategory) => !menuTypeVersionCategoriesSubcategories.some(
          (categorySubcategory) => isEqual(itemCategorySubcategory, categorySubcategory)
        )
      ))) {
        areCategoriesSubcategoriesDifferent = true;
      }
      ITEM_PRICES.forEach((priceKey) => {
        if (!menuTypeVersionPrices.includes(menuTypeVersion[priceKey])) {
          menuTypeVersionPrices.push(menuTypeVersion[priceKey]);
        }
        if (!prices.includes(menuTypeVersion[priceKey])) {
          prices.push(menuTypeVersion[priceKey]);
        }
      });
      if (!menuTypeVersion.is86ed) {
        quantity = menuTypeVersion.currentAmount;
      }
      const menuTypeVersionPriceText = calculatePriceText(
        menuTypeVersionPrices
      );
      const menuTypeVersionTaxesText = getTaxesTextPair(
        menuTypeVersionTaxIds,
        taxes
      );
      Object.values((_b = menuTypeVersion.categoriesSubcategories) != null ? _b : {}).forEach(
        ({ categoryId, subcategoryId }) => {
          if (categoryId)
            categoryIdSet.add(categoryId);
          if (subcategoryId)
            subcategoryIdSet.add(subcategoryId);
        }
      );
      const statuses = {};
      Object.values(item.menuTypeVersions).map((menuTypeVer) => {
        statuses[menuTypeVer.id] = menuTypeVer.active;
      });
      children.push({
        id: menuTypeVersion.menuTypeId,
        title: (_c = menuTypes[menuTypeVersion.menuTypeId]) == null ? void 0 : _c.name,
        upc: [menuTypeVersion.universalProductCode],
        categoryId: [],
        subcategoryId: [],
        menuTypeId: [menuTypeVersion.menuTypeId],
        isHidden: getIsMenuTypeItemHiddenCore(
          menuTypeVersion.categoriesSubcategories,
          categories,
          subcategories,
          "items",
          item.itemId,
          menuTypeVersion.menuTypeId,
          menuTypes
        ).isHidden,
        price: menuTypeVersionPriceText,
        taxes: menuTypeVersionTaxesText,
        quantity: null,
        categoriesSubcategories: getCategoriesSubcategoriesText(
          menuTypeVersionCategoriesSubcategories
        ),
        modifierGroups: getModifierGroupsText(menuTypeVersionModifierGroupIds),
        printerLocations: getPrinterLocationsText(
          menuTypeVersionPrinterLocationIds
        ),
        status: menuTypeVersion.active,
        customId: item.customId,
        taxInclusive: menuTypeVersion.taxInclusive,
        reportingGroups: getReportingGroupsText(item.reportingGroupIds),
        reportingGroupIds: item.reportingGroupIds,
        statuses
      });
    });
    const taxesText = areTaxesDifferent ? null : getTaxesTextPair(taxIds, taxes);
    const modifierGroupsText = areModifierGroupsDifferent ? null : getModifierGroupsText(modifierGroupIds);
    const printerLocationsText = arePrinterLocationsDifferent ? null : getPrinterLocationsText(printerLocationIds);
    const categoriesSubcategoriesText = areCategoriesSubcategoriesDifferent ? null : getCategoriesSubcategoriesText(categoriesSubcategories);
    return __spreadProps(__spreadValues({}, itemCoreCard), {
      price: calculatePriceText(prices),
      taxes: taxesText,
      quantity,
      categoriesSubcategories: categoriesSubcategoriesText,
      modifierGroups: modifierGroupsText,
      printerLocations: printerLocationsText,
      status: children.some((child) => child.status),
      customId: item.customId || "-",
      taxInclusive: Object.values(item.menuTypeVersions).every(
        (menuTypeVersion) => menuTypeVersion.taxInclusive
      ),
      children,
      reportingGroups: getReportingGroupsText(item.reportingGroupIds)
    });
  });
};

export { getTaxesTextPair, menuItemTableFactoryCore };
